import { render, staticRenderFns } from "./dataClearRecord.vue?vue&type=template&id=1ff71e6b&"
import script from "./dataClearRecord.vue?vue&type=script&lang=js&"
export * from "./dataClearRecord.vue?vue&type=script&lang=js&"
import style0 from "./dataClearRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports